import React from 'react';
import './BbBannerShared.css';

class Welcome extends React.Component {
  constructor(props) {
    super(props);
    this.handleCategorySelection = this.handleCategorySelection.bind(this);
  }

  handleCategorySelection(o) {
    this.props.handleCategorySelection(o);
  }

  render() {
    console.log('*** WELCOME ***');
    return (
      <div className="container-fluid bg-secondary">
        <div className="row g-0">
          <div className="col center">
            <div id="welcome" className="banner_shared">
              <h4>
                Hello
                {' '}
                {this.props.playerName}
                . Welcome to the game!
              </h4>
              <h5>You join the game when the next question loads.</h5>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Welcome;
